import en from '../languages/en.json';
import zh from '../languages/zh.json';
import jp from '../languages/jp.json';
import es from '../languages/es.json';
const locale = { en, zh, jp, es }
export default locale;



// WEBPACK FOOTER //
// ./src/languages/languages.js